import React, { useEffect, useState } from 'react';

import moment from 'moment'

import { DatePicker, Form, Input, InputNumber, Radio } from 'antd';

import { bloodGroups, heightUnits, l2navoptions, pulseRateUnit, tempratureUnit, weightUnits, bodyTemperatureposition, pulseRatePosition, bloodPressureUnit }
    from '../../../../../..//Helpers/InterBranchConstants';
import Dropdown from '../../../../../DropDown/Dropdown';
import { useSelector, useDispatch } from "react-redux";
import { book_appointment, book_Videoconsultaton, Store_formData, update_patient_vital_info,fetch_consultationNow,CreateMedicalinfo } from "../../../../../../actions/InterBranchCoordinatorAction"
import { convertDateToString } from '../../../../../../Helpers/dateFunctions';
import './patientvitals.css'
import { useHistory, useRouteMatch } from 'react-router-dom';
import { validateDataForFields } from '../../../../../../Helpers/helperFunctions';
import { useNavigationConfirmation } from '../../../../../../Helpers/Hooks/useNavigationConfirmation';
import UnsavedChangesConfirmation from '../../../../../../components/UnsavedChangesConfirmation/UnsavedChangesConfirmation';

function PatientVitals({ setActiveTop, onUnsavedChangesChange }) {


    let dispatch = useDispatch();
    let history = useHistory()
    let { path, url } = useRouteMatch();
    let reduxData = useSelector(state => state);
   // let patientId = reduxData?.interBranchCoordinator?.interBranchRegisterPatient?.data?.info;
   let patientId = localStorage.getItem("PatientId")
    let appointment_form = useSelector(state => state?.interBranchCoordinator?.appointment_form)
    let userDetails = JSON.parse(localStorage.getItem("userData"));
    const userId = userDetails.profileId;
    const [buttonClicked, setButtonClicked] = useState(null);
    let patientDetails = useSelector(state => state.interBranchCoordinator?.interBranchPatientDetails?.data?.patientDetails);
    let { chosendoctorId, chosenDate, chosenTime, typeOfConsultation, couponCode } = reduxData?.interBranchCoordinator?.appointment_form;

    console.log("*****patientDetails*******",patientDetails)
    const [vitalsForm] = Form.useForm();

    const isScheduled = () => url.includes("scheduleappointment")
let [resumevisible, setResumevisible] = useState(false)
    let [formData, setFormData] = useState({

        heightValue: "",
        heightUnit: "",
        weightValue: "",
        weightUnit: "",
        bmiValue: "",
        bloodGroup: "",
        lmp: "",

        bloodPressurSystolic: "",
        bloodPressurDiastolic: "",
        bloodPressurunit: "mmHG",
        bloodPressurAsOn: "",

        bodyTempratureValue: "",
        bodyTempratureUnit: "",
        bodyTempratureAsOn: "",
        bodyTempraturePosition: "",

        PulseRateValue: "",
        PulseRateUnit: "Beats/Min",
        PulseRateAsOn: "",
        PulseRatePosition: "",

        RespirationValue: "",
        RespirationUnit: "Beats/Min",
        RespirationAsOn: "",

    })

    const [isEditted, setEditted] = useState(false)
    const MINUTE_MS = 10000;
    // Function to check if there's actual data entered in the form
    const hasActualData = () => {
        const formValues = vitalsForm.getFieldsValue();
        
        // Check if any of the main fields have actual values
        const hasData = (
            // Basic vitals
            (formValues.heightValue && formValues.heightValue.toString().trim() !== '') ||
            (formValues.weightValue && formValues.weightValue.toString().trim() !== '') ||
            (formValues.bmiValue && formValues.bmiValue.toString().trim() !== '') ||
            (formValues.bloodGroup && formValues.bloodGroup.trim() !== '') ||
            (formValues.lmp && formValues.lmp !== null) ||
            
            // Blood pressure
            (formValues.bloodPressurSystolic && formValues.bloodPressurSystolic.toString().trim() !== '') ||
            (formValues.bloodPressurDiastolic && formValues.bloodPressurDiastolic.toString().trim() !== '') ||
            (formValues.bloodpressureMeasurementDate && formValues.bloodpressureMeasurementDate !== null) ||
            
            // Body temperature
            (formValues.bodyTempratureValue && formValues.bodyTempratureValue.toString().trim() !== '') ||
            (formValues.bodytempratureMeasurement && formValues.bodytempratureMeasurement.trim() !== '') ||
            (formValues.bodytempratureMeasurementDate && formValues.bodytempratureMeasurementDate !== null) ||
            (formValues.bodyTempraturePosition && formValues.bodyTempraturePosition.trim() !== '') ||
            
            // Pulse rate
            (formValues.PulseRateValue && formValues.PulseRateValue.toString().trim() !== '') ||
            (formValues.pulserateMeasurementDate && formValues.pulserateMeasurementDate !== null) ||
            (formValues.PulseRatePosition && formValues.PulseRatePosition.trim() !== '') ||
            
            // Respiration rate
            (formValues.RespirationValue && formValues.RespirationValue.toString().trim() !== '') ||
            (formValues.RespirationMeasurementDate && formValues.RespirationMeasurementDate !== null) ||
            
            // Unit selections (only if they're different from default)
            (formValues.heightMeasurement && formValues.heightMeasurement.trim() !== '') ||
            (formValues.weightMeasurement && formValues.weightMeasurement.trim() !== '')
        );
        
        return hasData;
    };

    // Navigation confirmation hook - only show if there's actual data
    const handleNavigationWithConfirmation = useNavigationConfirmation(
        hasActualData(),
        "You have unsaved changes in the patient vitals form. Are you sure you want to leave this section?"
    );

    // Wrapper function for setActiveTop that includes confirmation
    const handleSetActiveTop = (newActiveTop) => {
        handleNavigationWithConfirmation(() => {
            setActiveTop(newActiveTop);
        });
    };

    // Notify parent component when unsaved changes state changes
    useEffect(() => {
        if (onUnsavedChangesChange) {
            onUnsavedChangesChange(hasActualData());
        }
    }, [isEditted, onUnsavedChangesChange]); // Keep isEditted as dependency to trigger when form changes

    useEffect(() => {
    
           
            const interval = setInterval(() => {
                consultationnow()
            }, MINUTE_MS);
    
            return () => clearInterval(interval);
    
        })
    
        function consultationnow() {
            //findConsultationForNow
            try {
                dispatch(fetch_consultationNow(userId)).then((data) => {
    
    
                    if (data.data.appointmentId != undefined) {
                        setResumevisible(true)
                       // setconsultationId(data.data.appointmentId);
    
                    }
                    else {
    
                        setResumevisible(false)
                    }
    
                });
            } catch (error) {
                console.log("Error in fetch_clinic_speciality API", error);
            }
        }

    console.log("*******patientId******",patientId)
    //This useEffect will change the state with redux data in loading time
    

    //We can change the state by this method. (Object Itration in javascript)
    let handleChangeFormItem = ({ key, value }) => {


        setFormData({ ...formData, [key]: value })

    }



    const calculateBMI = ({ heightUnit, weightUnit, heightValue, weightValue }) => {
  // Normalize numeric inputs
  const rawHeight = parseFloat(heightValue) || 0;
  const rawWeight = parseFloat(weightValue) || 0;

  let heightMeters = 0;
  let weightKg = rawWeight;

  // --- Height Conversion ---
  switch (heightUnit) {
    case "in":
      heightMeters = rawHeight * 0.0254;
      break;

    case "ft": {
      // Convert feet directly to meters (1 ft = 0.3048 m)
      heightMeters = rawHeight * 0.3048;
      break;
    }

    case "cm":
      heightMeters = rawHeight / 100;
      break;

    default:
      // Assume height is already in meters
      heightMeters = rawHeight;
  }

  // --- Weight Conversion ---
  const lbsUnits = ["lbs", "Lbs", "LBs", "LB", "lb", "pounds", "Pounds"];
  const kgUnits = ["kg", "Kg", "KG", "kilograms", "Kilograms"];
  
  if (lbsUnits.includes(String(weightUnit))) {
    weightKg = rawWeight * 0.45359237;
  } else if (kgUnits.includes(String(weightUnit)) || !weightUnit) {
    // If kg or undefined/null, weight is already in kg
    weightKg = rawWeight;
  }

  console.info("Calculating BMI with:", { heightUnit, weightUnit, heightMeters, weightKg });

  // --- Calculate BMI ---
  if (heightMeters > 0 && weightKg > 0) {
    const bmi = (weightKg / Math.pow(heightMeters, 2)).toFixed(2);
    const bmiString = String(bmi);

    console.info("Calculated BMI:", bmiString);

    setFormData((prev) => ({
      ...prev,
      bmiValue: bmiString,
    }));

    // Force update the form field value
    vitalsForm.setFieldsValue({ bmiValue: bmiString });

    // Verify the value was set
    setTimeout(() => {
      console.info("Form BMI value after setting:", vitalsForm.getFieldValue('bmiValue'));
    }, 100);
  } else {
    console.warn("Invalid height or weight. Cannot calculate BMI.", { heightMeters, weightKg });
  }
};


    let saveData = () => {

        //Function moved to onFinish of form...............
    }

    const parseDate = (value) => {
        if (!value) return null;
        let m = moment(value, [
          'YYYY-MM-DDTHH:mm:ss.SSSZ',
          'YYYY-MM-DDTHH:mm:ssZ',
          'YYYY-MM-DD',
          'DD-MM-YYYY',
          'DD-MMM-YYYY'
        ], true);
      
        if (!m.isValid()) {
          // fallback to general moment parser
          m = moment(value);
        }
      
        return m.isValid() ? m : null;
      };
      
   const validateDataForFields = (val) => (val && val !== "null" ? val : undefined);

  const syncFormDataWithRedux = (existingData) => {
    // First check if we have unsaved changes in appointment_form (Redux), otherwise use patientDetails
    const reduxFormData = appointment_form || {};
    // Check multiple possible data locations
    const source = existingData || reduxFormData || patientDetails?.basicInfo || patientDetails || {};

    console.log("Source data for body temperature:", {
      bodytempraturePosition: source?.bodytempraturePosition,
      bodyTempraturePosition: source?.bodyTempraturePosition,
      bodytemprature: source?.bodytemprature,
      bodytempratureMeasurement: source?.bodytempratureMeasurement,
      bodytempratureMeasurementDate: source?.bodytempratureMeasurementDate
    });

    const normalizeSource = {
      ...source,
      // Check both direct fields (from appointment_form) and nested fields (from patientDetails)
      bodyTempratureValue: source?.bodyTempratureValue || (typeof source?.bodytemprature === 'string' || typeof source?.bodytemprature === 'number' ? source?.bodytemprature : "") || "",
      bodytempratureMeasurement: source?.bodytempratureMeasurement || "",
      bodytempratureMeasurementDate: parseDate(source?.bodytempratureMeasurementDate),
      bodyTempraturePosition: source?.bodyTempraturePosition || source?.bodytempraturePosition || "",

      PulseRateValue: source?.PulseRateValue || (typeof source?.pulserate === 'string' || typeof source?.pulserate === 'number' ? source?.pulserate : "") || "",
      PulseRateUnit: source?.PulseRateUnit || source?.pulserateMeasurement || "Beats/Min",
      pulserateMeasurementDate: parseDate(source?.pulserateMeasurementDate),
      PulseRatePosition: source?.PulseRatePosition || source?.pulserateMeasurementPosition || "",

      RespirationValue: source?.RespirationValue || (typeof source?.Respiration === 'string' || typeof source?.Respiration === 'number' ? source?.Respiration : "") || "",
      RespirationUnit: source?.RespirationUnit || source?.RespirationMeasurement || "Beats/Min",
      RespirationMeasurementDate: parseDate(source?.RespirationMeasurementDate),

      // Handle blood pressure from either format
      ...(source?.bloodPressurSystolic && source?.bloodPressurDiastolic
        ? {
            bloodPressurSystolic: source.bloodPressurSystolic,
            bloodPressurDiastolic: source.bloodPressurDiastolic,
            bloodPressurunit: source?.bloodPressurunit || "mmHG",
            bloodpressureMeasurementDate: parseDate(source?.bloodpressureMeasurementDate),
          }
        : source?.bloodpressure && typeof source.bloodpressure === 'string'
        ? (() => {
            const [systolic, diastolic] = source.bloodpressure.split("|").map((v) => v.trim());
            return {
              bloodPressurSystolic: systolic,
              bloodPressurDiastolic: diastolic,
              bloodPressurunit: source?.bloodpressureMeasurement || "mmHG",
              bloodpressureMeasurementDate: parseDate(source?.bloodpressureMeasurementDate),
            };
          })()
        : {}),
    };

    console.log("Normalized body temperature data:", {
      bodyTempratureValue: normalizeSource?.bodyTempratureValue,
      bodytempratureMeasurement: normalizeSource?.bodytempratureMeasurement,
      bodyTempraturePosition: normalizeSource?.bodyTempraturePosition
    });

    vitalsForm.setFieldsValue({
      heightValue: normalizeSource?.heightValue,
      heightMeasurement: validateDataForFields(normalizeSource?.heightMeasurement),
      weightMeasurement: validateDataForFields(normalizeSource?.weightMeasurement),
      weightValue: normalizeSource?.weightValue,
      bmiValue: normalizeSource?.bmiValue,
      bloodGroup: validateDataForFields(normalizeSource?.bloodGroup),
      lmp: parseDate(normalizeSource?.lmp),

      bloodPressurSystolic: normalizeSource?.bloodPressurSystolic,
      bloodPressurDiastolic: normalizeSource?.bloodPressurDiastolic,
      bloodPressurunit: normalizeSource?.bloodPressurunit,
      bloodpressureMeasurementDate: normalizeSource?.bloodpressureMeasurementDate,

      bodyTempratureValue: normalizeSource?.bodyTempratureValue,
      bodytempratureMeasurement: normalizeSource?.bodytempratureMeasurement||undefined,
      bodytempratureMeasurementDate: normalizeSource?.bodytempratureMeasurementDate,
      bodytempraturePosition: normalizeSource?.bodyTempraturePosition||undefined,

      PulseRateValue: normalizeSource?.PulseRateValue,
      PulseRateUnit: normalizeSource?.PulseRateUnit,
      pulserateMeasurementDate: normalizeSource?.pulserateMeasurementDate,
      PulseRatePosition: normalizeSource?.PulseRatePosition||undefined,

      RespirationValue: normalizeSource?.RespirationValue,
      RespirationUnit: normalizeSource?.RespirationUnit,
      RespirationMeasurementDate: normalizeSource?.RespirationMeasurementDate,
    });
    console.log("Setting form values:", normalizeSource);

    // Calculate BMI if height and weight values are present from API
    if (normalizeSource?.heightValue && normalizeSource?.weightValue) {
      console.log("Calculating BMI from API data:", {
        heightValue: normalizeSource?.heightValue,
        heightUnit: normalizeSource?.heightMeasurement,
        weightValue: normalizeSource?.weightValue,
        weightUnit: normalizeSource?.weightMeasurement,
      });
      
      setTimeout(() => {
        calculateBMI({
          heightUnit: normalizeSource?.heightMeasurement,
          weightUnit: normalizeSource?.weightMeasurement,
          heightValue: normalizeSource?.heightValue,
          weightValue: normalizeSource?.weightValue,
        });
      }, 100);
    }

    // Check if any fields have data and enable the save button
    // Need to check for actual values, not just empty strings or undefined
    const checkValue = (val) => {
      if (val === null || val === undefined || val === "" || val === "null") {
        return false;
      }
      // Check if it's a moment object that's valid
      if (moment.isMoment(val)) {
        return val.isValid();
      }
      return true;
    };

    const hasData = (
      checkValue(normalizeSource?.heightValue) ||
      checkValue(normalizeSource?.heightMeasurement) ||
      checkValue(normalizeSource?.weightValue) ||
      checkValue(normalizeSource?.weightMeasurement) ||
      checkValue(normalizeSource?.bmiValue) ||
      checkValue(normalizeSource?.bloodGroup) ||
      checkValue(normalizeSource?.lmp) ||
      checkValue(normalizeSource?.bloodPressurSystolic) ||
      checkValue(normalizeSource?.bloodPressurDiastolic) ||
      checkValue(normalizeSource?.bloodpressureMeasurementDate) ||
      checkValue(normalizeSource?.bodyTempratureValue) ||
      checkValue(normalizeSource?.bodytempratureMeasurement) ||
      checkValue(normalizeSource?.bodytempratureMeasurementDate) ||
      checkValue(normalizeSource?.bodytempraturePosition) ||
      checkValue(normalizeSource?.PulseRateValue) ||
      checkValue(normalizeSource?.pulserateMeasurementDate) ||
      checkValue(normalizeSource?.PulseRatePosition) ||
      checkValue(normalizeSource?.RespirationValue) ||
      checkValue(normalizeSource?.RespirationMeasurementDate)
    );

    console.log("Has data after load:", hasData);

    if (hasData) {
      setEditted(true);
    } else {
      setEditted(false);
    }

  };

    useEffect(() => {
        console.log("Patient/appointment data changed, syncing form data...");
        console.log("patientDetails full:", patientDetails);
        console.log("patientDetails?.basicInfo:", patientDetails?.basicInfo);
        console.log("appointment_form:", appointment_form);
        syncFormDataWithRedux();

    }, [patientDetails, appointment_form])


    let allowOnlyunumber = (e) => {

        if (e.target.value.includes(".") && e.key == ".") {
            e.preventDefault()
        }

        !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "Backspace"].includes(e.key) && e.preventDefault()

    }



    const onFinishVitals = (values) => {

        if (buttonClicked === "Save") {
            console.log("Saving values :--------------- ", values);

            dispatch(
                Store_formData({
                    ...reduxData.interBranchCoordinator.appointment_form,
                    ...values
                })
            ).then((res) => {


                dispatch(update_patient_vital_info(patientId, { ...appointment_form, ...values })).then((res) => {
                    // Clear the edited state since we're saving
                setEditted(false);
                
                dispatch(CreateMedicalinfo(patientId, localStorage.getItem("appointmentId")))
                // Notify parent that there are no more unsaved changes
                if (onUnsavedChangesChange) {
                    onUnsavedChangesChange(false);
                }

                setActiveTop(l2navoptions[1])

                history.push(`/dashboard/${url.includes("bookandconsult") ? "bookandconsult" : "scheduleappointment"}/patientmedical/lifestyle`)

                })

                
            })
        }
        if (buttonClicked === "Join") {
            try {
                dispatch(book_Videoconsultaton(patientId, userId, chosendoctorId, typeOfConsultation, couponCode, chosenTime, chosenDate, appointment_form)).
                    then((res) => {

                        if (res.data.appointmentId != "Time slot already choosen by some other person. Please try with different slot, Sorry for the inconvenience.") {

                            localStorage.setItem("AppointmentId", res.data.appointmentId)
                            history.push("/meetspoke/"+res.data.appointmentId);
                        }

                    })
            } catch (error) {
                //console.log("Error in book_appointment API", error);
            }
        }


    }

    const onFinishFailedVitals = (error) => {

        console.log(error);
    }

    const onChangeFieldValue = (value, allValues) => {


        if (
            !allValues.PulseRatePosition &&
            !allValues.PulseRateValue &&
            !allValues.RespirationMeasurementDate &&
            !allValues.RespirationValue &&
            !allValues.bloodGroup &&
            !allValues.bloodPressurDiastolic &&
            !allValues.bloodPressurSystolic && 
            !allValues.bloodpressureMeasurementDate &&
            !allValues.bmiValue &&
            !allValues.bodyTempraturePosition &&
            !allValues.bodyTempratureValue &&
            !allValues.bodytempratureMeasurement &&
            !allValues.bodytempratureMeasurementDate &&
            !allValues.heightMeasurement &&
            !allValues.heightValue &&
            !allValues.lmp &&
            !allValues.pulserateMeasurementDate &&
            !allValues.weightMeasurement &&
            !allValues.weightValue
        ) {

            console.log("No data filled................");
            setEditted(false)

        }
        else {
            setEditted(true)
        }


        let key = Object.keys(value)[0]

        console.log("Form field changed:", key, "value:", value[key]);
        console.log("All form values:", allValues);

        if (key === "heightValue" || key === "heightMeasurement" || key === "weightValue" || key === "weightMeasurement") {

            console.log("Triggering BMI calculation with:", {
                heightUnit: allValues?.heightMeasurement,
                weightUnit: allValues?.weightMeasurement,
                heightValue: allValues?.heightValue,
                weightValue: allValues?.weightValue,
            });

            // Use setTimeout to ensure form state has updated before calculating
            setTimeout(() => {
                calculateBMI({
                    heightUnit: allValues?.heightMeasurement,
                    weightUnit: allValues?.weightMeasurement,
                    heightValue: allValues?.heightValue,
                    weightValue: allValues?.weightValue,
                })
            }, 0);

        }

        // Store unsaved changes to Redux immediately so they persist across page navigation
        dispatch(
            Store_formData({
                ...reduxData.interBranchCoordinator.appointment_form,
                ...allValues
            })
        )


    }


    console.log("..................formData........................", formData);

    return (

        <div className='patient-medical-container'>

            <Form
                form={vitalsForm}
                name="vitalsForm"
                onFinish={onFinishVitals}
                onFinishFailed={onFinishFailedVitals}
                onValuesChange={onChangeFieldValue}
                autoComplete="off"
                preserve={true}
            >

                <div className="patient-medical-container_row">
                    <div className="item-container">

                        <div className="caption">Height</div>

                        <div className='blue-light-back'>

                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`heightValue`}
                            >
                                <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input"
                                    maxLength={6}
                                    onChange={(e) => {
                                        handleChangeFormItem({ key: "heightValue", value: e.target.value });
                                    }}
                                    placeholder="Height" />

                            </Form.Item>
                            {/* ........................................................................................................... */}



                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`heightMeasurement`}
                            >
                                <Dropdown
                                    onChange={(e) => {
                                        handleChangeFormItem({ key: "heightMeasurement", value: e });
                                    }}
                                    data={heightUnits} width={100}
                                    placeholder="Select"
                                />
                            </Form.Item>
                            {/* ........................................................................................................... */}

                        </div>

                    </div>

                    <div className="item-container">

                        <div className="caption">Weight</div>

                        <div className='blue-light-back'>


                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`weightValue`}
                            >
                                <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input" min={1} maxLength={6} width={100}
                                    placeholder="Weight"
                                    onChange={(e) => {
                                        handleChangeFormItem({ key: "weightValue", value: e.target.value });
                                    }}

                                />
                            </Form.Item>
                            {/* ........................................................................................................... */}


                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`weightMeasurement`}
                            >
                                <Dropdown
                                    onChange={(e) => {
                                        handleChangeFormItem({ key: "weightMeasurement", value: e });
                                    }}
                                    data={weightUnits} width={100}
                                    placeholder="Select"
                                />

                            </Form.Item>
                            {/* ........................................................................................................... */}
                        </div>

                    </div>

                    <div className="item-container">

                        <div className="caption">BMI</div>

                        <div className='blue-light-back'>

                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`bmiValue`}
                            >
                                <Input
                                    className="patient-vitals-number-input"
                                    style={{ margin: "0px !important", width: "100%" }}
                                    placeholder="BMI"
                                    readOnly
                                />
                            </Form.Item>
                            {/* ........................................................................................................... */}
                        </div>

                    </div>

                    <div className="item-container">

                        <div className="caption">Blood Group</div>

                        <div className='blue-light-back'>


                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`bloodGroup`}
                            >
                                <Dropdown
                                    onChange={(e) => { handleChangeFormItem({ key: "bloodGroup", value: e }) }}
                                    data={bloodGroups} width={100}
                                    placeholder="Select"
                                // onChange={(e) => setBloodGroup(e.value)} 
                                />
                            </Form.Item>
                            {/* ........................................................................................................... */}

                        </div>

                    </div>

                    <div className="item-container">

                        <div className="caption">LMP</div>

                        <div className='blue-light-back'>

                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`lmp`}
                            >
                                <DatePicker
                                    getPopupContainer={trigger => trigger.parentNode}
                                    inputReadOnly
                                    placeholder='DD-MM-YYYY'
                                    format='DD-MM-yyyy'
                                    className='date-input'
                                    disabledDate={(current) => {
                                        return current && current.valueOf() > Date.now();
                                    }}
                                    onChange={(e) => { handleChangeFormItem({ key: "lmp", value: convertDateToString(e) }) }}
                                />

                            </Form.Item>
                            {/* ........................................................................................................... */}
                        </div>

                    </div>


                </div>



                <div className="patient-medical-container_row">
                    <div className="item-container">

                        <div className="patient-medical-container_row">

                            <div className="caption">Blood Pressure</div>

                            {/* <Radio.Group value={1}>
                            <Radio value={1}>Physical</Radio>
                            <Radio value={2}>Connect a Device</Radio>ṣ
                        </Radio.Group> */}

                        </div>

                        <div className="patient-medical-container_row">

                            <div className='blue-light-back'>

                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bloodPressurSystolic`}
                                >
                                    <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input"
                                        // onKeyDown={validateNumber}
                                        min={1}
                                        maxLength={6}
                                        onChange={(e) => { handleChangeFormItem({ key: "bloodPressurSystolic", value: e.target.value }) }}
                                        style={{ width: "120px" }} placeholder="Systolic" />
                                </Form.Item>
                                {/* ........................................................................................................... */}


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bloodPressurDiastolic`}
                                >
                                    <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input"
                                        // onKeyDown={validateNumber}
                                        maxLength={6}
                                        onChange={(e) => { handleChangeFormItem({ key: "bloodPressurDiastolic", value: e.target.value }) }}
                                        style={{ width: "120px" }} placeholder="Diastolic" />
                                </Form.Item>
                                {/* ........................................................................................................... */}



                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bloodPressurunit`}
                                >
                                    <Input
                                        style={{ width: "120px" }} width={100} placeholder={"mmHG"} readOnly />

                                </Form.Item>
                                {/* ........................................................................................................... */}



                                <span className='ason2'>as on</span>
                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bloodpressureMeasurementDate`}
                                >
                                    <DatePicker
                                        getPopupContainer={trigger => trigger.parentNode}
                                        inputReadOnly
                                        placeholder='DD-MM-YYYY'
                                        format='DD-MM-yyyy'
                                        className='date-input'
                                        disabledDate={(current) => {
                                            return current && current.valueOf() > Date.now();
                                        }}
                                        onChange={(e, d) => { handleChangeFormItem({ key: "bloodpressureMeasurementDate", value: d }) }}
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}

                            </div>

                            {/* <div className="past-readings">
                            <img src={require('../../../../../../assets/InterBranch/PNGIcons/medical-records.png')} alt="" />
                            <span> See past readings</span>

                        </div> */}

                        </div>



                    </div>
                </div>



                <div className="patient-medical-container_row">
                    <div className="item-container">

                        <div className="patient-medical-container_row">

                            <div className="caption">Body Temperature</div>

                            {/* <Radio.Group value={1}>
                            <Radio value={1}>Physical</Radio>
                            <Radio value={2}>Connect a Device</Radio>ṣ
                        </Radio.Group> */}

                        </div>

                        <div className="patient-medical-container_row">

                            <div className='blue-light-back'>

                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bodyTempratureValue`}
                                >
                                    <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input"
                                        onChange={(e) => { handleChangeFormItem({ key: "bodyTempratureValue", value: e.target.value }) }}
                                        min={1} maxLength={6}
                                        placeholder="Temperature"

                                    // onKeyDown={validateNumber} 
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bodytempratureMeasurement`}
                                    
                                >
                                    <Dropdown
                                        data={tempratureUnit} width={150}
                                        placeholder="Select"
                                        onChange={(e) => { handleChangeFormItem({ key: "bodytempratureMeasurement", value: e }) }}
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}

                                <span className='ason2'>as on</span>

                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bodytempratureMeasurementDate`}
                                >
                                    <DatePicker
                                        getPopupContainer={trigger => trigger.parentNode}
                                        placeholder='DD-MM-YYYY'
                                        inputReadOnly format='DD-MM-yyyy'
                                        className='date-input'
                                        disabledDate={(current) => {
                                            return current && current.valueOf() > Date.now();
                                        }}
                                        onChange={(e, d) => { handleChangeFormItem({ key: "bodytempratureMeasurementDate", value: d }) }}
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bodytempraturePosition`}
                                >
                                    <Dropdown
                                        onChange={(e) => { handleChangeFormItem({ key: "bodyTempraturePosition", value: e }) }}
                                        data={bodyTemperatureposition} placeholder="Position" width={170}
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}

                            </div>

                            {/* <div className="past-readings">
                            <img src={require('../../../../../../assets/InterBranch/PNGIcons/medical-records.png')} alt="" />
                            <span> See past readings</span>

                        </div> */}

                        </div>



                    </div>
                </div>


                <div className="patient-medical-container_row">
                    <div className="item-container">

                        <div className="patient-medical-container_row">

                            <div className="caption">Pulse Rate</div>

                            {/* <Radio.Group value={1}>
                            <Radio value={1}>Physical</Radio>
                            <Radio value={2}>Connect a Device</Radio>ṣ
                        </Radio.Group> */}

                        </div>

                        <div className="patient-medical-container_row">

                            <div className='blue-light-back'>


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`PulseRateValue`}
                                >
                                    <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input"
                                        onChange={(e) => { handleChangeFormItem({ key: "PulseRateValue", value: e.target.value }) }}
                                        min={1} maxLength={6}
                                        placeholder="Pulse"
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`PulseRateUnit`}
                                >
                                    <Input
                                        style={{ width: "120px" }} width={100} placeholder={"Beats/Min"} readOnly />
                                </Form.Item>
                                {/* ........................................................................................................... */}


                                <span className='ason2'>as on</span>

                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`pulserateMeasurementDate`}
                                >
                                    <DatePicker
                                        getPopupContainer={trigger => trigger.parentNode}
                                        inputReadOnly
                                        format='DD-MM-yyyy'
                                        placeholder='DD-MM-YYYY'
                                        className='date-input'
                                        disabledDate={(current) => {
                                            return current && current.valueOf() > Date.now();
                                        }}
                                        onChange={(e, d) => { handleChangeFormItem({ key: "pulserateMeasurementDate", value: d }) }}
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}

                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`PulseRatePosition`}
                                >
                                    <Dropdown
                                        onChange={(e) => { handleChangeFormItem({ key: "PulseRatePosition", value: e }) }}
                                        data={pulseRatePosition} placeholder="Position" width={176}
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}

                            </div>

                            {/* <div className="past-readings">
                            <img src={require('../../../../../../assets/InterBranch/PNGIcons/medical-records.png')} alt="" />
                            <span> See past readings</span>

                        </div> */}

                        </div>



                    </div>
                </div>


                <div className="patient-medical-container_row">
                    <div className="item-container">

                        <div className="patient-medical-container_row">

                            <div className="caption">Respiration Rate</div>

                            {/* <Radio.Group value={1}>
                            <Radio value={1}>Physical</Radio>
                            <Radio value={2}>Connect a Device</Radio>ṣ
                        </Radio.Group> */}

                        </div>

                        <div className="patient-medical-container_row">

                            <div className='blue-light-back'>


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`RespirationValue`}
                                >
                                    <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input"
                                        onChange={(e) => { handleChangeFormItem({ key: "RespirationValue", value: e.target.value }) }}
                                        min={1}
                                        maxLength={6}
                                        placeholder="Respiration" />
                                </Form.Item>
                                {/* ........................................................................................................... */}



                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`RespirationUnit`}
                                >
                                    <Input
                                        style={{ width: "120px" }} width={100} placeholder={"Beats/Min"} readOnly />
                                </Form.Item>
                                {/* ........................................................................................................... */}


                                <span className='ason2'>as on</span>


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`RespirationMeasurementDate`}
                                >
                                    <DatePicker
                                        onChange={(e, d) => { handleChangeFormItem({ key: "RespirationMeasurementDate", value: d }) }}
                                        getPopupContainer={trigger => trigger.parentNode}
                                        inputReadOnly
                                        format='DD-MM-yyyy'
                                        placeholder='DD-MM-YYYY'
                                        className='date-input'
                                        disabledDate={(current) => {
                                            return current && current.valueOf() > Date.now();
                                        }} />
                                </Form.Item>
                                {/* ........................................................................................................... */}

                            </div>

                            {/* <div className="past-readings">
                            <img src={require('../../../../../../assets/InterBranch/PNGIcons/medical-records.png')} alt="" />
                            <span> See past readings</span>

                        </div> */}

                        </div>



                    </div>

                </div>



                <div className="button-container">

                    <button type='submit' className='submt-btn' disabled={!isEditted} onClick={() => { setButtonClicked("Save") }}>SAVE</button>


                    {
                        !isScheduled() && !resumevisible &&
                        <button type='submit' className='join-btn' onClick={() => { setButtonClicked("Join") }}>SKIP AND JOIN CONSULTATION</button>
                        // :
                        // <button disabled={!isCouponCodeVerified()} className='join-btn' onClick={() => setButtonClicked("Book")}>BOOK APPOINTMENT</button>
                    }


                </div>

            </Form>
            
            {/* Unsaved Changes Confirmation Modal */}
            <UnsavedChangesConfirmation />
        </div>

    )
}

export default PatientVitals;
